import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import React from "react";
import { Icon, ModalContent, ModalHeader, ModalWindow, ModalWrapper } from "./styles";
import { WashroomsFormModalProps } from "./types";
import { WashroomsForm } from "src/components/molecules/WashroomsForm";

const WashroomsFormModal = ({ closeModal, defaultValues, onSubmit, errorMsg, isEditMode }: WashroomsFormModalProps) => {
  return (
    <ModalWrapper>
      <ModalWindow style={{ maxWidth: "315px" }}>
        <ModalHeader>
          <div>
            <span>{isEditMode ? "Edit Washroom" : "Add Washroom"}</span>
            <Icon onClick={closeModal} icon={faTimesCircle as IconProp} />
          </div>
        </ModalHeader>
        <ModalContent>
          <WashroomsForm
            defaultValues={defaultValues}
            onCancel={closeModal}
            onSubmit={onSubmit}
            errorMsg={errorMsg ?? ""}
            isEditMode={isEditMode}
          />
        </ModalContent>
      </ModalWindow>
    </ModalWrapper>
  );
};
export default WashroomsFormModal;
